import { TextValide } from "../../../stringhelper/TextValide";
import { ExternalLog } from "../../../externalLogging/ExternalLog";
import { IntSignal } from "../../../signal/IntSignal";
import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { IEnvironmentGlobals } from "../../IEnvironmentGlobals";
import { BasicCommandVO } from "../../controller/commands/BasicCommandVO";
import { SmartfoxEvent } from "../../event/SmartfoxEvent";
import { NetworkInstance, WorldAssignment, WorldAssignmentFacade } from "@goodgamestudios/world-assignment";
import { Timer } from "@goodgamestudios/createjs-utilities";
import { Signal } from "signals.js";
import { SMARTFOX_CLIENT } from "../../../../../index";
import { getLogger } from "@goodgamestudios/logger";
import { Room } from "../../smartfox/data/Room";
import { ServerErrorLOFactory } from "../../../externalLogging/factories/ServerErrorLOFactory";
import { XML } from "@goodgamestudios/xml-e4x";


import EventDispatcher = createjs.EventDispatcher;
import TimerEvent = createjs.TimerEvent;
const logger = getLogger(SMARTFOX_CLIENT);

const MSG_STR: string = "%";
const header: string = "<msg t='sys'>";
const xmlMsg: string = "<ver v='166' />";
const SPACE_SUBSTITUDE: string = "<RoundHouseKick>";
const MAX_GAMESERVER_ERROR_DELAY_TIME: number = 10000;
const DEFAULT_PING: number = 60000;
export class BasicSmartfoxClient extends EventDispatcher {


    public static LOBBY_ROOM_NAME: string = "Lobby";
    public static S2C_ROOMLIST: string = "rlu";
    public static S2C_VERSION_CHECK: string = "vck";
    public static S2C_JOIN_ROOM: string = "jro";
    public static S2C_PING: string = "pin";

    //TEMP
    private hasAutojoined: boolean = false;
    private _roundTripTime: number = 0;
    private _roundTripStartTime: number;
    private _connectionTime: number = 0;
    /**
     * This value is used by game to check if ConnectionLost Event was dispatch following a Socket.Close happened because of Network issues, Server disconnections etc or after a manual logout by user or our client.
     * (imho we should not send ConnectionLost when loggin out...   but all games are now relying on that event and checking this property )
     * @type {boolean}
     * @private
     */
    private _userForcedDisconnect: boolean = false;
    private _ip: string;
    private _port: number;

    // Callbacks
    public roundTripResponseSignal: Signal;

    private gameServerErrorDelayTimer: Timer;


    private currentGameServerErrorLogFunction: Function;

    private worldAssignmentFacade: WorldAssignmentFacade;

    private activeRoomId: number;
    public playerId: number;
    private defaultZone: string;

    private socket: WebSocket;
    private roomList: any[] = [];

    private commandBuffer = "";

    constructor() {
        super();
        this.roundTripResponseSignal = new Signal();
        this.onAvgNetworkLagTimeResponse = new IntSignal();
        this.worldAssignmentFacade = (window.ggs.worldAssignment as WorldAssignment).facade;
    }

    public  executeConnection(ip: string, port: number = 443): void {
        this._userForcedDisconnect = false;
        if (port !== 443) {
            logger.warn("HTML5 games currently support only WSS on 443");
            port = 443;
        }
        // TODO HTML5 we might need to change something when/if we will implement bluebox connection
        this._ip = ip;
        this._port = port;
        const protocol = "wss";
        // once closed (because user logged out or connection was lost) socket cannot be reopened
        // therefore we alwasy create a new one.
        // in case we get here and socket is still connected at least make sure we dont leave it open...

        if (this.socket && (this.socket.readyState === WebSocket.CONNECTING || this.socket.readyState === WebSocket.OPEN)) {
            this.socket.onerror = undefined; // fix strage edge Error: Network Error 12030
            this.socket.onclose = undefined; // we dont want to trigger any dialog when switching servers
            this.socket.onmessage = undefined;
            this.socket.onopen = undefined;
            this.socket.close(4999, "shutting down socket before opening a new one");
        }

        // reset flag since previous socket connection is reseted
        this.hasAutojoined = false;

        this._connectionTime = Date.now();
        this.dispatchEvent(new SmartfoxEvent(SmartfoxEvent.CONNECT_START));

        this.socket = new WebSocket(`${protocol}://${ip}:${port}`);
        logger.debug("Will connect to " + this.socket.url);

        // quick test to check if we are leaking sockets and listeners
        // if (!(<any>window).allSockets) {
        //     (<any>window).allSockets = [];
        // }
        // (<any>window).allSockets.push(this.socket);


        this.socket.onopen = () => {
            logger.debug("Connected");
            this.sendXMLMessage(header, "verChk", 0, xmlMsg);
        };

        this.socket.onerror = (ev) => {
            logger.error(`websocket encounter unknow error`);
            this.dispatchEvent(new SmartfoxEvent(SmartfoxEvent.CONNECT_FAILED));
        };

        this.socket.onmessage = this.handleSocketData.bind(this);

        this.socket.onclose = (ev) => {
            logger.debug(`Socket onclose:  (${ev.code}) ${ev.reason}`);
            // in theory we should be able to get the reason and code back that we sent with the close command.  and base on that discern if it was a logout or a connection lost  but socket seems to receive always code 1006 (Abnormal Closure)
            // this._userForcedDisconnect = manualDisconnectionCodes.includes(ev.code);
            // if (this.policyPingTest) {
            //     this.policyPingTest.dispose();
            // }
            this.hasAutojoined = false;

            this.socket.onerror = undefined; // fix strage edge Error: Network Error 12030
            this.socket.onopen = undefined;
            this.socket.onmessage = undefined;
            this.socket.onclose = undefined;
            this.dispatchEvent(new SmartfoxEvent(SmartfoxEvent.CONNECTION_LOST));
        };

    }


    public executeRoundTrip(): void {
        // Do a round trip
        this.doRoundTripBench();
    }

    private onRoundTripResponse({CTS}): void {
        this._roundTripTime = CTS - this._roundTripStartTime;
        this.roundTripResponseSignal.dispatch(this._roundTripTime, this.isConnectedViaHTTP());
    }


    /**
     * reference onCompleteMethod
     * start gameServerErrorDelayTimer with delay of 10 sec
     *
     * @param onCompleteMethod:Function
     */
    public startGameServerErrorDelayTimer(onCompleteMethod: Function): void {
        this.currentGameServerErrorLogFunction = onCompleteMethod;
        this.gameServerErrorDelayTimer = new Timer(MAX_GAMESERVER_ERROR_DELAY_TIME);
        this.gameServerErrorDelayTimer.addEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.currentGameServerErrorLogFunction));
        this.gameServerErrorDelayTimer.start();
    }

    /**
     * stop gameServerErrorDelayTimer and remove currentGameServerErrorLogFunction as EventHandler
     */
    private disposeGameServerErrorDelayTimer(): void {
        if (this.gameServerErrorDelayTimer) {
            this.gameServerErrorDelayTimer.stop();
            this.gameServerErrorDelayTimer.removeEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.currentGameServerErrorLogFunction));
            this.gameServerErrorDelayTimer = null;
        }
    }

    /**
     * do internal and external Log
     * restart gameServerErrorDelayTimer
     */
    private onRoomListFailed(): void {
        this.disposeGameServerErrorDelayTimer();
        let instanceVO: NetworkInstance = this.worldAssignmentFacade.selectedNetworkInstance;
        ExternalLog.logger.log(new ServerErrorLOFactory(ServerErrorLOFactory.ROOMLIST_FAILED, instanceVO.zone, this.isConnectedViaHTTP()));
        this.startGameServerErrorDelayTimer(this.bindFunction(this.onRoomListFailed));
        logger.error("RoomList failed!");
    }

    /**
     * do internal and external Log
     * restart gameServerErrorDelayTimer
     */
    private onJoinRoomFailed(): void {
        this.disposeGameServerErrorDelayTimer();
        let instanceVO: NetworkInstance = this.worldAssignmentFacade.selectedNetworkInstance;
        ExternalLog.logger.log(new ServerErrorLOFactory(ServerErrorLOFactory.JOINROOM_FAILED, instanceVO.zone, this.isConnectedViaHTTP()));
        this.startGameServerErrorDelayTimer(this.bindFunction(this.onJoinRoomFailed));
        logger.error("JoinRoom failed!");
    }

    /**
     * do internal and external Log
     * restart gameServerErrorDelayTimer
     */
    public onLoginResponseFailed(): void {
        this.disposeGameServerErrorDelayTimer();
        let instanceVO: NetworkInstance = this.worldAssignmentFacade.selectedNetworkInstance;
        ExternalLog.logger.log(new ServerErrorLOFactory(ServerErrorLOFactory.LOGIN_RESPONCE_FAILED, instanceVO.zone, this.isConnectedViaHTTP()));
        this.startGameServerErrorDelayTimer(this.bindFunction(this.onLoginResponseFailed));
        logger.error("LoginResponce failed!");
    }

    /**
     * IMPORTANT!!!
     * stops gameServerErrorDelayTimer after LoginResponce
     * Use this method in your game after getting responce from server after trying login
     */
    public /*final*/ onLoginResponceSuccess(): void {
        this.disposeGameServerErrorDelayTimer();
    }


    private onExtensionResponse(cmdId: string, params: any): void {
        logger.debug(`received ext command: [${cmdId}](${params})`);
        switch (cmdId) {
            case BasicSmartfoxClient.S2C_ROOMLIST:
                this.disposeGameServerErrorDelayTimer();
                this.startGameServerErrorDelayTimer(this.bindFunction(this.onJoinRoomFailed));
                this.setRoomList(params);
                if (!this.hasAutojoined) {
                    this.hasAutojoined = true;
                    this.sendXMLMessage(header, "autoJoin", -1, "");
                }
                return;
            default:
                // remove roomId from params of other commands
                const roomId = params.shift();
                this.dispatchEvent(new SmartfoxEvent(SmartfoxEvent.EXTENSION_RESPONSE, cmdId, params));
                return;
        }
    }

    private setRoomList(data: any[]): void {
        const FLAG_PRIVATE: number = 0;
        const FLAG_TEMP: number = 1;
        const FLAG_GAME: number = 2;
        const FLAG_LIMBO: number = 3;

        // unpack
        let rId: number = data[1];
        let rUCount: number = this.decompressInt(data[2]);
        let rUMax: number = this.decompressInt(data[3]);
        let rFlags: number = this.decompressInt(data[4]);
        let rName: string = data[5];
        // create room
        this.roomList[rId] = new Room(rId, rName, rUMax, 0,
            ((rFlags >> FLAG_TEMP) & 1) === 1,
            ((rFlags >> FLAG_GAME) & 1) === 1,
            ((rFlags >> FLAG_PRIVATE) & 1) === 1,
            ((rFlags >> FLAG_LIMBO) & 1) === 1,
            rUCount, 0);
        logger.debug("Rooms: ", this.roomList);
        // let params: any = {roomList : this.roomList};
        // this.sfc.dispatchEvent(new SFSEvent(SFSEvent.onRoomListUpdate, params));
    }

    private decompressInt(input: string): number {
        const ASCII_FRIST_INDEX: number = "A".charCodeAt(0);
        const ASCII_LAST_INDEX: number = "z".charCodeAt(0);
        const ASCII_RANGE: number = ASCII_LAST_INDEX - ASCII_FRIST_INDEX + 1;
        let result: number = 0;
        if (input && input.length > 0) {
            for (let i: number = input.length - 1; i >= 0; i--) {
                // range error ?
                if (input.charCodeAt(i) < ASCII_FRIST_INDEX || input.charCodeAt(i) > ASCII_LAST_INDEX) {
                    return -1;
                }
                result = result * ASCII_RANGE + input.charCodeAt(i) - ASCII_FRIST_INDEX;
            }
        }
        return result;
    }

    /**
     * Join Room
     * If join to Lobby start Timer and set Eventlistener
     */
    private onJoinRoom(): void {
        this.disposeGameServerErrorDelayTimer();

        let joinedRoomName: string = this.activeRoom;
        if (joinedRoomName === BasicSmartfoxClient.LOBBY_ROOM_NAME) {
            this.doRoundTripBench();
            this.activatePing(DEFAULT_PING);
        }
        logger.debug("onJoinRoom:: received signal roomJoined --> will dispatch joinedRoom  Smartfox event");
        this.dispatchEvent(new SmartfoxEvent(SmartfoxEvent.JOINED_ROOM, "", [joinedRoomName]));
    }

    public changePingTimer(timeInMs: number): void {
        this.activatePing(timeInMs);
    }


    private pingInterval: number;

    /**
     * Createjs.Timer relies on CreateJs.Ticker which - based on sync status - can hava a fix Timeout or use RAF window.requestAnimationFrame()
     * to improve performance of Tabs,  browser block requestAnimationFrame on hidden tabs
     * this is good.  as ticker / updates etc are paused.
     * but in case of the ping we need it to continue otherwise Socket will disconnect after 15 minutes ( see JIRA HTML-4455)
     * @param time
     */
    private activatePing(timeInMs) {
        if (this.pingInterval) {
            clearInterval(this.pingInterval);
        }
        logger.debug(`activating ping every ${timeInMs} ms`);
        this.pingInterval = setInterval(() => {
            this.sendMessage(BasicSmartfoxClient.S2C_PING, [""]);
        }, timeInMs);
    }

    /**
     * client logout
     * remove Eventlistener
     */
    public logout(): void {

        logger.debug("logout");
        this.disposeGameServerErrorDelayTimer();
        if (this.pingInterval) {
            clearInterval(this.pingInterval);
        }
        // this.socket.onclose = undefined; // keep it since we rely on the onClose event to notify game
        this._userForcedDisconnect = true;  //  unfortunately it seems we cant have back the code we sent therefore we need to manually set this bolean here
        this.socket.close(4000, "manually disconnected");
    }


    /**
     * Send message to Server with MessageId and params
     */
    public sendMessage(msgId: string, params: any[]): void {
        logger.debug("BasicSmartfoxClient sendMessage: " + msgId + " params: " + params);
        for (let i: number = 0; i < params.length; i++) {
            if (params[i] === 0) {
                params[i] = "0";
            } else if (!params[i]) {
                params[i] = SPACE_SUBSTITUDE;
            } else if (typeof params[i] === "string") {
                params[i] = TextValide.getValideSmartFoxText(params[i]);
            }
        }
        this.sendCommand(this.defaultZone, msgId, params, this.activeRoomId);
    }

    public sendEmptyCommandVO(commandVO: BasicCommandVO): void {
        this.sendMessage(commandVO.getCmdId(), []);
    }

    public sendCommandVO(commandVO: BasicCommandVO): void {
        if (!this.env.useLaggyClientEmulation) {
            // just fire away
            this.sendMessage(commandVO.getCmdId(), [JSON.stringify(commandVO)]);
        } else {
            logger.warn("Be Aware:  testing laggy client emulation");
            // fire the event delayed
            setTimeout(function (): void {
                this.sendMessage(commandVO.getCmdId(), [JSON.stringify(commandVO)]);
            }, this.getRandomLag());
        }
    }


    private getRandomLag = () => (this.env.laggyClientMaxDelay - this.env.laggyClientMinDelay) * Math.random() + this.env.laggyClientMinDelay;

    private doRoundTripBench(): void {
        this._roundTripStartTime = Date.now();
        this.sendXMLMessage(header, "roundTrip", this.activeRoomId, "");
    }

    public isConnectedViaHTTP(): number {
        return 0;
    }

    public get userForcedDisconnect(): boolean {
        return this._userForcedDisconnect;
    }

    public get connectionTime(): number {
        return this._connectionTime;
    }

    public get roundTripTime(): number {
        return this._roundTripTime;
    }

    public get ip(): string {
        return this._ip;
    }

    public get port(): number {
        return this._port;
    }


    public get activeRoom(): string {
        let room: Room = this.getRoom(this.activeRoomId);
        return room ? room.getName() : "Not available.";
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }


    private login(zone: string, name: string, pass: string) {
        const message: string = "<login z='" + zone + "'><nick><![CDATA[" + name + "]]></nick><pword><![CDATA[" + pass + "]]></pword></login>";
        this.sendXMLMessage(header, "login", 0, message);
    }

    /**
     * Send a request to a server side extension.
     * The request can be serialized using three different protocols: XML, JSON .
     * XML and JSON can both serialize complex objects with any level of nested properties, while the String protocol allows to sendXMLMessage linear data delimited by a separator
     * The String-based protocol can be very useful for realtime applications/games where reducing the amount of data is the highest priority.
     * @param    xtName:        the name of the extension (see also the {@link #createRoom} method).
     * @param    cmd:        the name of the action/command to execute in the extension.
     * @param    paramObj:    an object containing the data to be passed to the extension (set to empty object if no data is required).
     * @param    roomId:        the id of the room where the request was originated, in case of multi-room join (optional, default value: {@link #activeRoomId}).
     */

    private sendCommand(xtName: string, cmd: string, paramObj: string[], roomId: number = -1) {
        if (!this.socket) {
            logger.warn(`[Wanted to send xtMessage]: ${xtName + " " + cmd}  BUT socket hasn't been initialized yet.`);
            return;
        }
        const msg = ["", "xt", xtName, cmd, roomId, ...paramObj, ""].join(MSG_STR);
        if (this.isConnected) {
            logger.debug("[Sending xtMessage]: " + msg);
            this.socket.send(msg);
        } else {
            // TODO HTML5 check why if socket is in state 3  (Closed) we didnt stop the game and displayd LostConnection Dialog
            logger.warn(`[Wanted to send xtMessage]: ${msg}  BUT socket has state: ${this.socket.readyState}`);
        }
    }


    private sendXMLMessage(messageHeader: string, action: string, fromRoom: number, message: string) {

        if (this.isConnected) {
            const xmlMsg2 = messageHeader + `<body action='${action}' r='${fromRoom}'>${message}</body></msg>`;
            logger.debug("[Sending XMLMessage]: " + xmlMsg2.replace(/]]>/g, "] ]>") + "\n"); // add extra space to fix junit reporter, no nesting <!CDATA[]>
            this.socket.send(xmlMsg2);
        } else {
            // TODO HTML5  do we really want this?
            logger.warn("socket not ready, scheduling retry");
            setTimeout(() => {
                logger.warn("[sretrying to sendXMLMessage...");
                this.sendXMLMessage(messageHeader, action, fromRoom, message);
            }, 50);
        }
    }


    public get isConnected(): boolean {
        return this.socket && this.socket.readyState === WebSocket.OPEN;
    }

    private handleSocketData(ev: MessageEvent) {
        const reader = new FileReader();
        reader.onloadend = () =>  this.onDataReady(reader.result);
        reader.readAsText(ev.data, "utf-8");
    }

    private onDataReady(msg: string) {
        // preserve original msg length
        const originalLangth = msg.length;
        // remove surrogate chars and unicode chars
        msg = msg.replace(/[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g, "");
        logger.debug("[ RECEIVED ]: " + msg + ", (len: " + originalLangth + ")");

        //buffer everything
        this.commandBuffer += msg;

        const endCheck = (s) => /}?%$/.test(s);

        // step 1: extract and execute system command
        const sysCommandPatter: RegExp = /<msg[\s\S]+<\/msg>/g;
        const systemCommands: string[] = this.commandBuffer.match(sysCommandPatter);
        if (systemCommands && systemCommands.length > 0) {
            systemCommands.forEach((sysCommand) => {
                this.handleSystemMessage(sysCommand);
            });
            this.commandBuffer = this.commandBuffer.replace(sysCommandPatter, "");
        }
        // step 2: check if the buffer ends with ext command ending
        // TODO if we have a clear pattern of ext command, we can extracted as system command, we dont need to wait for an end
        if (endCheck(this.commandBuffer)) {
            let parts: string[] = this.commandBuffer.split("%xt");
            this.commandBuffer = "";
            for (let i: number = 0; i < parts.length; i++) {
                if (parts[i].length > 0) {
                    this.handleExtMessage(parts[i]);
                }
            }
        }
    }


    /**
     * These are the usual server messages  (Smartfox Extensions) - bound to Game Commands
     * sent as JSON
     * @param msg
     */
    public handleExtMessage(msg: string) {
        let parts = msg.substring(1, msg.length - 1).split("%");
        let cmd: string = parts.shift();
        this.onExtensionResponse(cmd, parts);
    }

    /**
     * These are the message  in charge of main connection / roundtrip and Joinroom
     * They are the only messages still sent as XML
     * @param msg
     */
    public handleSystemMessage(msg: string) {
        let obj: XML = XML(msg);

        let action: String = obj.child("body").attribute("action");
        switch (action) {
            case "apiOK":
                logger.debug("apiOK received");
                this._connectionTime = Date.now() - this._connectionTime;

                this.disposeGameServerErrorDelayTimer();
                this.startGameServerErrorDelayTimer(this.bindFunction(this.onRoomListFailed));

                let instanceVO: NetworkInstance = this.worldAssignmentFacade.selectedNetworkInstance;
                this.defaultZone = instanceVO.zone;

                this.login(instanceVO.zone, "", this.env.versionDateGame + MSG_STR + this.worldAssignmentFacade.currentCountry.ggsLanguageCode + MSG_STR + this.env.distributorId);
                this.dispatchEvent(new SmartfoxEvent(SmartfoxEvent.CONNECT_SUCCESS));
                break;

            case "joinOK":
                let roomId: number = Number(obj.child("body").attribute("r"));
                this.activeRoomId = roomId;

                let playerId: number = Number(obj.child("body").child("pid").attribute("id"));
                // Set the player ID
                // -1 = no game room
                this.playerId = playerId;
                this.onJoinRoom();
                break;
            case "roundTripRes":
                this.onRoundTripResponse({CTS: Date.now()});
                break;
            default:
                logger.warn("Unexpected sys message: " + action);
        }
    }

    private getRoom(roomId: number): Room {
        return this.roomList[roomId];
    }


    public checkAvgNetworkLagTime(delay: number = 4000, repeatCount: number = 8): void {
        this.stopAvgNetworkLagTimer();
        this.totalPingTime = 0;
        this.pingCount = 0;
        this.roundTripResponseSignal.add(this.bindFunction(this.avgNetworkLagResponseHandler));
        this.averageNetworkLagTimer = new Timer(delay, repeatCount);
        this.averageNetworkLagTimer.addEventListener(TimerEvent.TIMER, this.bindFunction(this.avgNetworkLagTimerListener));
        this.averageNetworkLagTimer.addEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.avgNetworkLagTimerDone));
        this.averageNetworkLagTimer.start();
    }

    public onAvgNetworkLagTimeResponse: IntSignal;

    public stopAvgNetworkLagTimer(): void {
        if (this.averageNetworkLagTimer) {
            this.roundTripResponseSignal.remove(this.bindFunction(this.avgNetworkLagResponseHandler));
            this.averageNetworkLagTimer.stop();
            this.averageNetworkLagTimer.removeEventListener(TimerEvent.TIMER, this.bindFunction(this.avgNetworkLagTimerListener));
            this.averageNetworkLagTimer.removeEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.avgNetworkLagTimerDone));
            this.averageNetworkLagTimer = null;
        }
    }

    // average network lag time
    private averageNetworkLagTimer: Timer;
    private totalPingTime: number = 0;
    private pingCount: number = 0;


    private avgNetworkLagTimerDone(e: TimerEvent): void {
        this.stopAvgNetworkLagTimer();
    }

    private avgNetworkLagTimerListener(e: TimerEvent): void {
        this.doRoundTripBench();
    }

    private avgNetworkLagResponseHandler(roundtripTime: number): void {
        this.totalPingTime += roundtripTime / 2;
        this.pingCount++;
        let avg: number = Math.round(this.totalPingTime / this.pingCount);
        this.onAvgNetworkLagTimeResponse.signal(avg);
    }


}
